import { create } from 'zustand';

/**
 * Minimal UI state for the app shell.
 *
 * Adapted from GovynOS `ui-store` but stripped down: no theme, no density,
 * no persisted workspace id — Mana Locals resolves scope via `getWorkspaceResolution`
 * and doesn't persist UI preferences yet.
 */
interface UiState {
  sidebarCollapsed: boolean;
  mobileNavOpen: boolean;
  profilePanelOpen: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleSidebar: () => void;
  setMobileNavOpen: (open: boolean) => void;
  setProfilePanelOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  mobileNavOpen: false,
  profilePanelOpen: false,
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setMobileNavOpen: (open) => set({ mobileNavOpen: open }),
  setProfilePanelOpen: (open) => set({ profilePanelOpen: open }),
}));

export function useSidebarCollapsed() {
  return useUiStore((state) => state.sidebarCollapsed);
}

export function useToggleSidebar() {
  return useUiStore((state) => state.toggleSidebar);
}

export function useMobileNavOpen() {
  return useUiStore((state) => state.mobileNavOpen);
}

export function useSetMobileNavOpen() {
  return useUiStore((state) => state.setMobileNavOpen);
}

export function useProfilePanelOpen() {
  return useUiStore((state) => state.profilePanelOpen);
}

export function useSetProfilePanelOpen() {
  return useUiStore((state) => state.setProfilePanelOpen);
}
